import DocumentAlertListViewDTO = App.Data.Alerts.DocumentAlertListViewDTO;
import DocumentAlertDO = App.Data.Alerts.DocumentAlertDO;

export default function (alert: DocumentAlertListViewDTO | DocumentAlertDO) {
	const aboveOrBelow = alert.type === "above_threshold" ? "above" : "below";

	return `Any value ${aboveOrBelow} ${alert.formatted_value}`;
}
